import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { I18nProvider } from "./i18n";
import Header from "./components/site/Header";
import Footer from "./components/site/Footer";
import CookieBanner from "./components/site/CookieBanner";
import ScrollToTop from "./components/site/ScrollToTop";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Terms from "./pages/Terms";
import ThankYou from "./pages/ThankYou";
import NotFound from "./pages/NotFound";

const LangLayout = ({ children }) => {
  const { lang } = useParams();
  const safeLang = lang === "en" ? "en" : "ec";

  useEffect(() => {
    document.documentElement.lang = safeLang === "ec" ? "es-EC" : "en";
  }, [safeLang]);

  return (
    <I18nProvider lang={safeLang}>
      <div className="min-h-screen flex flex-col bg-[#0B1120] text-slate-100">
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
};

const LangSwitchGuard = () => {
  const location = useLocation();
  const path = location.pathname;
  if (path === "/" || path === "") return <Navigate to="/ec" replace />;
  if (path === "/ec" || path === "/en") return null;
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ec" replace />} />
        <Route
          path="/thank_you"
          element={
            <I18nProvider lang="ec">
              <div className="min-h-screen flex flex-col bg-[#0B1120] text-slate-100">
                <ThankYou />
              </div>
            </I18nProvider>
          }
        />
        <Route
          path="/:lang"
          element={
            <LangLayout>
              <Home />
            </LangLayout>
          }
        />
        <Route
          path="/:lang/privacy"
          element={
            <LangLayout>
              <Privacy />
            </LangLayout>
          }
        />
        <Route
          path="/:lang/cookies"
          element={
            <LangLayout>
              <Cookies />
            </LangLayout>
          }
        />
        <Route
          path="/:lang/terms"
          element={
            <LangLayout>
              <Terms />
            </LangLayout>
          }
        />
        <Route
          path="*"
          element={
            <I18nProvider lang="ec">
              <div className="min-h-screen flex flex-col bg-[#0B1120] text-slate-100">
                <Header />
                <NotFound />
                <Footer />
                <CookieBanner />
              </div>
            </I18nProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
